import {type CompletedCreatorBrandSafetyVettingStatus} from '@/types/creatorBrandSafetyVetting';

export const PLACEHOLDER_ID = 'placeholder';
export const COMPLETED_REPORT_STATUSES: CompletedCreatorBrandSafetyVettingStatus[] =
  ['approved', 'declined', 'ready_for_review', 'report_failed'];
